import { Button, Grid, styled } from "@mui/material";
import get from "lodash/get";
import React from "react";
import { connect } from "react-redux";
import { SCOPES, audit_tabs } from "./constants";
import operations from "./ducks/operations";
import PermissionsGate from "./permissions/PermissionsGate";

const StyledPageToolbar = styled(Grid)({
    marginTop: "20px",
    marginBottom: "20px",
});

// Equivalent of `flexDisplay`
const StyledFlexDisplay = styled(Grid)({
    display: "flex",
});

const AuditCompsTitle = (props) => {
    const { searchResponse, activeTab, updateDealAuditFlags, comps, auditorListList } = props;
    const { auditorSearch, auditorList } = audit_tabs;
    return (
        <React.Fragment>
            <StyledPageToolbar container justifyContent="space-between" alignItems="center" spacing={12}>
                <Grid item xs={3}>
                    <h2>Comps</h2>
                    <div className="page-subtitle">
                        {get(searchResponse, "results", null) &&
                            `Showing ${searchResponse.results.length} ${
                                searchResponse.results.length === 1
                                    ? "comp"
                                    : `comps (${searchResponse.totalResultCount} TOTAL)`
                            }`}
                    </div>
                </Grid>
                <PermissionsGate hide scopes={[SCOPES.canAddToList]}>
                    <StyledFlexDisplay item xs={2} justifyContent="flex-end">
                        {activeTab === auditorSearch && (
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => updateDealAuditFlags(comps, true)}
                            >
                                Add to Audit List
                            </Button>
                        )}
                        {activeTab === auditorList && (
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => updateDealAuditFlags(auditorListList, false)}
                            >
                                Remove from Audit List
                            </Button>
                        )}
                    </StyledFlexDisplay>
                </PermissionsGate>
            </StyledPageToolbar>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    activeTab: state.auditReducer.activeTab,
    comps: state.auditReducer.comps,
    auditorListList: state.auditReducer.auditorList,
});
const mapDispatchToProps = (dispatch) => ({
    updateDealAuditFlags: (list, auditFlag) => {
        dispatch(operations.updateDealAuditFlags(list, auditFlag));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditCompsTitle);
